/**
 * Traveler booking forms, OCR, companions, team file — tuples [ko, en, vi, ru].
 */

function pick(map, langIndex) {
  const out = {};
  Object.entries(map).forEach(([k, v]) => {
    if (Array.isArray(v) && v.length >= 4) out[k] = v[langIndex];
    else if (v && typeof v === 'object' && !Array.isArray(v)) out[k] = pick(v, langIndex);
    else out[k] = v;
  });
  return out;
}

const extraFields = {
  hotelName: ['호텔명', 'Hotel name', 'Tên khách sạn', 'Название отеля'],
  hotelNamePh: ['예: 빈펄 리조트 다낭', 'e.g. Vinpearl Resort Da Nang', 'vd: Vinpearl Resort Da Nang', 'напр. Vinpearl Resort Da Nang'],
  hotelNameHint: ['공항 픽업 시 가이드가 활용하는 정보예요', 'Used by the guide for airport pickup', 'Hướng dẫn viên dùng khi đón sân bay', 'Для встречи в аэропорту'],
  hotelNameHintShort: ['공항 픽업 시 필요해요', 'Needed for airport pickup', 'Cần để đón sân bay', 'Нужно для встречи в аэропорту'],
  hotelConfirm: ['호텔 컨펌 넘버', 'Hotel confirmation no.', 'Mã xác nhận khách sạn', 'Номер брони отеля'],
  hotelConfirmHint: ['호텔 예약 확인 번호예요', 'Hotel booking confirmation number', 'Mã xác nhận đặt phòng', 'Номер подтверждения брони'],
  hotelConfirmPh: ['예: ABC123456', 'e.g. ABC123456', 'vd: ABC123456', 'напр. ABC123456'],
  specialRequests: ['특별 요청사항', 'Special requests', 'Yêu cầu đặc biệt', 'Особые пожелания'],
  specialRequestsPh: ['예: 휠체어 필요, 채식 식사 요청', 'e.g. wheelchair, vegetarian meals', 'vd: xe lăn, ăn chay', 'напр. инвалидная коляска, вегетарианское меню'],
  residentId: ['주민등록번호 (보험사 요구 시)', 'National ID (if insurer requires)', 'CMND/CCCD (nếu bảo hiểm yêu cầu)', 'Нац. ID (если требует страховщик)'],
  residentIdShort: ['주민등록번호', 'National ID', 'CMND/CCCD', 'Нац. ID'],
  residentIdHint: [
    '국내 보험사 실명 인증에 필요해요. Mingo에 저장되지 않으며 보험사에만 전달 후 즉시 파기됩니다.',
    'Needed for Korean insurer ID checks. Not stored in Mingo; sent to the insurer then destroyed.',
    'Dùng xác minh bảo hiểm Hàn. Mingo không lưu; gửi rồi hủy ngay.',
    'Для проверки страховщика. Mingo не хранит; передаётся и сразу уничтожается.',
  ],
  residentIdHintBooking: [
    '여행자보험 가입을 위해 여행사에 안전하게 전달됩니다. Mingo 서버에 저장되지 않으며 보험 가입 후 즉시 파기됩니다.',
    'Sent securely to the agency for travel insurance. Not stored on Mingo; destroyed after enrollment.',
    'Gửi an toàn cho công ty lữ hành để bảo hiểm. Mingo không lưu; hủy sau khi đăng ký.',
    'Безопасно передаётся агентству для страховки. Mingo не хранит; уничтожается после оформления.',
  ],
  residentFrontPh: ['앞 6자리', 'First 6 digits', '6 số đầu', 'Первые 6 цифр'],
  birthDateHint: ['여행자보험 가입에 필요해요', 'Needed for travel insurance', 'Cần cho bảo hiểm du lịch', 'Нужно для страховки'],
  passportNameHintLong: ['가이드 피켓에 표시될 이름이에요', 'Shown on the guide pickup sign', 'Hiện trên biển đón', 'На табличке встречи'],
};

const extraErrors = {
  nameRequired: ['한글 성명을 입력해 주세요', 'Enter your name', 'Nhập họ tên', 'Введите имя'],
  consentRequired: ['필수 동의 항목에 체크해 주세요', 'Please accept the required consents', 'Vui lòng đồng ý các mục bắt buộc', 'Примите обязательные согласия'],
};

const formUi = {
  title: ['여행자 정보 입력', 'Traveler details', 'Thông tin du khách', 'Данные путешественника'],
  sectionBasic: ['기본 정보', 'Basic info', 'Thông tin cơ bản', 'Основные данные'],
  sectionPassport: ['여권 정보', 'Passport', 'Hộ chiếu', 'Паспорт'],
  sectionInsurance: ['보험 가입 정보', 'Insurance details', 'Bảo hiểm', 'Страховка'],
  sectionPickup: ['픽업 정보', 'Pickup', 'Đón khách', 'Трансфер'],
  sectionOther: ['기타', 'Other', 'Khác', 'Прочее'],
  sectionConsent: ['개인정보 동의', 'Privacy consent', 'Đồng ý bảo mật', 'Согласие на данные'],
  sectionBasicPassport: ['기본 · 여권 정보', 'Basic & passport', 'Cơ bản và hộ chiếu', 'Основные и паспорт'],
  sectionPickupOther: ['픽업 · 기타', 'Pickup & other', 'Đón khách và khác', 'Трансфер и прочее'],
  sectionResident: ['주민등록번호', 'National ID', 'CMND/CCCD', 'Нац. ID'],
  profileLoaded: ['마이페이지 여행자 정보를 불러왔어요', 'Loaded traveler details from My Page', 'Đã tải thông tin du khách từ Trang của tôi', 'Данные загружены из профиля'],
  agreeAll: ['전체 동의', 'Agree to all', 'Đồng ý tất cả', 'Согласен со всем'],
  required: ['필수', 'Required', 'Bắt buộc', 'Обязательно'],
  optional: ['선택', 'Optional', 'Tuỳ chọn', 'Необязательно'],
  details: ['자세히 보기', 'Details', 'Chi tiết', 'Подробнее'],
  collapse: ['접기', 'Hide', 'Thu gọn', 'Скрыть'],
  collectLabel: ['개인정보 수집 및 이용 동의', 'Collect and use personal data', 'Thu thập và sử dụng dữ liệu', 'Сбор и использование данных'],
  collectSummary: [
    '성명, 생년월일, 연락처를 여행 서비스 제공 목적으로 수집합니다.',
    'We collect name, date of birth, and phone for travel services.',
    'Thu thập họ tên, ngày sinh, điện thoại để cung cấp dịch vụ du lịch.',
    'Собираем имя, дату рождения и телефон для туристических услуг.',
  ],
  collectSummaryShort: [
    '성명, 생년월일, 연락처를 여행 서비스 목적으로 수집합니다.',
    'We collect name, date of birth, and phone for the trip.',
    'Thu thập họ tên, ngày sinh, điện thoại cho chuyến đi.',
    'Собираем имя, дату рождения и телефон для поездки.',
  ],
  collectDetail: [
    '성명, 생년월일, 연락처, 여권 정보, 호텔 정보 등을 여행 서비스 제공(보험 가입, 픽업, 담당자 안내) 목적으로 수집·이용합니다.',
    'We collect name, DOB, contact, passport, and hotel details to provide travel services (insurance, pickup, staff notices).',
    'Thu thập họ tên, ngày sinh, liên hệ, hộ chiếu, khách sạn để cung cấp dịch vụ (bảo hiểm, đón, thông báo nhân sự).',
    'Собираем ФИО, дату рождения, контакт, паспорт и отель для услуг (страховка, встреча, уведомления).',
  ],
  collectDetailShort: [
    '성명, 생년월일, 연락처, 여권 정보, 호텔 정보 등을 여행 서비스 제공 목적으로 수집·이용합니다.',
    'We collect name, DOB, contact, passport, and hotel details to provide travel services.',
    'Thu thập họ tên, ngày sinh, liên hệ, hộ chiếu, khách sạn để cung cấp dịch vụ du lịch.',
    'Собираем ФИО, дату рождения, контакт, паспорт и отель для туристических услуг.',
  ],
  thirdLabel: ['개인정보 제3자 제공 동의', 'Share data with third parties', 'Chia sẻ dữ liệu với bên thứ ba', 'Передача данных третьим лицам'],
  thirdSummary: [
    '여행자보험 가입을 위해 보험사에 여권/주민번호 정보가 제공됩니다. 보험 가입 후 즉시 파기됩니다.',
    'Passport/ID may be sent to the insurer for travel insurance, then destroyed right after enrollment.',
    'Hộ chiếu/CMND gửi cho bảo hiểm rồi hủy ngay sau khi đăng ký.',
    'Паспорт/ID передаётся страховщику и сразу уничтожается после оформления.',
  ],
  thirdSummaryBooking: [
    '여행자보험 가입을 위해 여행사에 정보가 전달됩니다. 보험 가입 후 즉시 파기됩니다.',
    'Details are sent to the agency for travel insurance, then destroyed after enrollment.',
    'Thông tin gửi công ty lữ hành để bảo hiểm, rồi hủy sau khi đăng ký.',
    'Данные передаются агентству для страховки и уничтожаются после оформления.',
  ],
  thirdDetail: [
    '여행자보험 가입을 위해 보험사에 여권번호·주민등록번호(입력 시) 등이 제공됩니다. 보험 가입 후 즉시 파기됩니다.',
    'Passport number and national ID (if entered) are sent to the insurer, then destroyed after enrollment.',
    'Số hộ chiếu và CMND (nếu nhập) gửi bảo hiểm, rồi hủy sau khi đăng ký.',
    'Номер паспорта и нац. ID (если указан) передаются страховщику и уничтожаются после оформления.',
  ],
  marketingLabel: ['마케팅 수신 동의', 'Marketing messages', 'Nhận tin marketing', 'Маркетинговые сообщения'],
  marketingSummary: ['이벤트·할인 안내를 받을 수 있습니다.', 'You may receive event and discount updates.', 'Có thể nhận ưu đãi và sự kiện.', 'Можно получать акции и скидки.'],
  marketingDetail: [
    '이벤트·할인·신규 상품 안내를 앱 푸시·이메일·문자로 받을 수 있습니다.',
    'You may receive event, discount, and new-product updates via push, email, or SMS.',
    'Có thể nhận sự kiện, giảm giá, sản phẩm mới qua push, email hoặc SMS.',
    'Акции, скидки и новинки можно получать push, email или SMS.',
  ],
  marketingDetailShort: [
    '이벤트·할인 안내를 앱 푸시·이메일·문자로 받을 수 있습니다.',
    'You may receive event and discount updates via push, email, or SMS.',
    'Có thể nhận sự kiện và giảm giá qua push, email hoặc SMS.',
    'Акции и скидки можно получать push, email или SMS.',
  ],
};

const ocr = {
  fail: ['인식이 어려워요. 직접 입력해주세요.', 'Could not read it. Please enter manually.', 'Không đọc được. Vui lòng nhập tay.', 'Не распознано. Введите вручную.'],
  cameraFail: ['카메라를 사용할 수 없어요. 앨범에서 선택해 주세요.', 'Camera unavailable. Choose from the album.', 'Không dùng được camera. Chọn từ album.', 'Камера недоступна. Выберите из альбома.'],
  applied: ['여권 정보가 입력됐어요. 내용을 확인해 주세요.', 'Passport fields filled. Please check them.', 'Đã điền hộ chiếu. Vui lòng kiểm tra.', 'Паспорт заполнен. Проверьте данные.'],
  scanning: ['인식 중…', 'Reading…', 'Đang đọc…', 'Чтение…'],
  scanBtn: ['여권 촬영하고 자동 입력', 'Scan passport to autofill', 'Chụp hộ chiếu để điền', 'Сфотографировать паспорт'],
  album: ['앨범', 'Album', 'Thư viện ảnh', 'Галерея'],
  hint: [
    '여권 하단 두 줄(MRZ)이 잘 보이게 찍어주세요. 영문명/여권번호/생년월일/만료일이 자동으로 입력됩니다.',
    'Capture the two MRZ lines at the bottom. Name, passport no., DOB, and expiry will fill in.',
    'Chụp rõ hai dòng MRZ dưới hộ chiếu. Tên, số hộ chiếu, ngày sinh, hạn sẽ được điền.',
    'Снимите две строки MRZ внизу. Имя, номер, дата рождения и срок заполнятся сами.',
  ],
  storageNote: ['여권 사진은 저장되지 않아요. 정보 추출 후 즉시 삭제됩니다.', 'Passport photos are not stored. Deleted right after extraction.', 'Ảnh hộ chiếu không lưu. Xóa ngay sau khi trích.', 'Фото паспорта не хранится. Удаляется сразу после извлечения.'],
  previewAlt: ['여권 미리보기', 'Passport preview', 'Xem trước hộ chiếu', 'Превью паспорта'],
  shoot: ['촬영', 'Capture', 'Chụp', 'Снять'],
  confirmAria: ['OCR 확인', 'Confirm scan', 'Xác nhận quét', 'Подтверждение скана'],
  confirmTitle: ['이렇게 인식됐어요. 맞나요?', 'Is this correct?', 'Đúng vậy chứ?', 'Так верно?'],
  labelEnName: ['영문명', 'Name', 'Tên', 'Имя'],
  labelPassNo: ['여권번호', 'Passport no.', 'Số hộ chiếu', 'Номер паспорта'],
  labelDob: ['생년월일', 'Date of birth', 'Ngày sinh', 'Дата рождения'],
  labelExpiry: ['만료일', 'Expiry', 'Hạn', 'Срок'],
  yes: ['맞아요', 'Yes', 'Đúng', 'Да'],
  retake: ['다시 찍기', 'Retake', 'Chụp lại', 'Снять снова'],
  planNoOcr: ['이 플랜에서는 OCR을 사용할 수 없어요. 직접 입력해 주세요.', 'OCR is not on this plan. Please enter manually.', 'Gói này không có OCR. Vui lòng nhập tay.', 'OCR нет в этом тарифе. Введите вручную.'],
  quota: ['이번 달 OCR 크레딧을 모두 사용했어요. 직접 입력해 주세요.', 'This month’s OCR credits are used up. Please enter manually.', 'Hết lượt OCR tháng này. Vui lòng nhập tay.', 'Кредиты OCR на месяц закончились. Введите вручную.'],
  unavailable: ['OCR을 사용할 수 없어요. 직접 입력해 주세요.', 'OCR is unavailable. Please enter manually.', 'Không dùng được OCR. Vui lòng nhập tay.', 'OCR недоступен. Введите вручную.'],
  checkFail: ['OCR 확인 실패', 'Could not check OCR', 'Không kiểm tra được OCR', 'Не удалось проверить OCR'],
};

const companion = {
  title: ['동반 여행자 정보', 'Travel companions', 'Người đi cùng', 'Спутники'],
  subtitle: [
    '함께 여행하는 분들의 정보를 입력해주세요.',
    'Add details for people traveling with you.',
    'Nhập thông tin người đi cùng.',
    'Укажите данные тех, кто едет с вами.',
  ],
  subtitleIns: ['여행자보험 가입에 필요해요.', 'Needed for travel insurance.', 'Cần cho bảo hiểm du lịch.', 'Нужно для страховки.'],
  person: ['동반자 {n}', 'Companion {n}', 'Người {n}', 'Спутник {n}'],
  remove: ['삭제', 'Remove', 'Xóa', 'Удалить'],
  relationship: ['관계', 'Relationship', 'Quan hệ', 'Родство'],
  add: ['동반자 추가', 'Add companion', 'Thêm người', 'Добавить спутника'],
  save: ['동반자 정보 저장', 'Save companions', 'Lưu người đi cùng', 'Сохранить спутников'],
  saved: ['동반자 정보가 저장됐어요', 'Companions saved', 'Đã lưu người đi cùng', 'Спутники сохранены'],
  relSpouse: ['배우자', 'Spouse', 'Vợ/chồng', 'Супруг(а)'],
  relChild: ['자녀', 'Child', 'Con', 'Ребёнок'],
  relParent: ['부모', 'Parent', 'Cha mẹ', 'Родитель'],
  relFriend: ['친구', 'Friend', 'Bạn', 'Друг'],
  relOther: ['기타', 'Other', 'Khác', 'Другое'],
};

const teamFile = {
  title: ['팀파일', 'Trip file', 'Hồ sơ đoàn', 'Файл поездки'],
  loadFailed: ['불러오기 실패', 'Could not load', 'Không tải được', 'Не удалось загрузить'],
  loading: ['불러오는 중…', 'Loading…', 'Đang tải…', 'Загрузка…'],
  confirmedOnly: ['확정된 예약의 팀파일만 조회할 수 있습니다.', 'Only confirmed bookings have a trip file.', 'Chỉ xem hồ sơ đoàn khi đặt đã xác nhận.', 'Файл поездки только у подтверждённых броней.'],
  peopleCount: ['{n}명', '{n} guests', '{n} khách', '{n} гостей'],
  guide: ['가이드', 'Guide', 'Hướng dẫn', 'Гид'],
  vehicle: ['차량', 'Vehicle', 'Xe', 'Авто'],
  lodging: ['숙소', 'Stay', 'Chỗ ở', 'Проживание'],
  forGuide: ['가이드용 정보', 'For the guide', 'Cho hướng dẫn viên', 'Для гида'],
  guest: ['손님', 'Guest', 'Khách', 'Гость'],
  request: ['요청', 'Request', 'Yêu cầu', 'Запрос'],
  vehicleMax: ['차량: {type} (최대 {n}명)', 'Vehicle: {type} (max {n})', 'Xe: {type} (tối đa {n})', 'Авто: {type} (до {n})'],
  staffTitle: ['담당자 배정', 'Assigned staff', 'Phân công nhân sự', 'Назначение персонала'],
  departureNotice: ['출발 안내', 'Departure info', 'Thông tin khởi hành', 'Информация о выезде'],
  enterBefore: ['출발 전 입력해주세요', 'Please fill this in before departure', 'Nhập trước khi khởi hành', 'Заполните до выезда'],
  notifyOnSave: ['저장 시 고객에게 알림이 발송됩니다.', 'The guest will be notified when you save.', 'Khách sẽ nhận thông báo khi bạn lưu.', 'Гость получит уведомление при сохранении.'],
  notifyOnSaveShort: ['저장 시 고객에게 알림이 발송됩니다', 'The guest will be notified when you save', 'Khách sẽ nhận thông báo khi bạn lưu', 'Гость получит уведомление при сохранении'],
  localGuide: ['로컬 가이드', 'Local guide', 'Hướng dẫn địa phương', 'Местный гид'],
  driver: ['차량 기사', 'Driver', 'Tài xế', 'Водитель'],
  name: ['이름', 'Name', 'Tên', 'Имя'],
  phone: ['전화번호', 'Phone', 'Điện thoại', 'Телефон'],
  kakao: ['카카오톡', 'KakaoTalk', 'KakaoTalk ID', 'КакаоТок'],
  plate: ['차량 번호', 'Plate number', 'Biển số', 'Номер авто'],
  carType: ['차종', 'Vehicle type', 'Loại xe', 'Тип авто'],
  call: ['전화하기', 'Call', 'Gọi', 'Позвонить'],
  staffPending: ['출발 전 담당자 정보가 안내될 예정입니다.', 'Staff details will be shared before departure.', 'Sẽ gửi thông tin nhân sự trước khi khởi hành.', 'Данные персонала придут до выезда.'],
  itinerary: ['투어 일정표', 'Tour itinerary', 'Lịch trình tour', 'Программа тура'],
  itineraryEmpty: ['일정표를 불러오는 중이거나 등록된 일정이 없습니다.', 'Loading itinerary, or none is registered yet.', 'Đang tải lịch hoặc chưa có lịch.', 'Загрузка программы или она ещё не добавлена.'],
  dayItem: ['일정', 'Stop', 'Điểm', 'Пункт'],
  includes: ['포함사항', 'Included', 'Bao gồm', 'Включено'],
  excludes: ['불포함사항', 'Not included', 'Không gồm', 'Не включено'],
  optionalCosts: ['선택경비', 'Optional costs', 'Chi phí tùy chọn', 'Доп. расходы'],
  notes: ['유의사항', 'Notes', 'Lưu ý', 'Замечания'],
  cancelRefund: ['취소/환불', 'Cancel / refund', 'Hủy / hoàn tiền', 'Отмена / возврат'],
  emergency: ['비상연락처', 'Emergency contact', 'Liên hệ khẩn', 'Экстренный контакт'],
  packing: ['준비물 체크리스트', 'Packing checklist', 'Danh sách mang theo', 'Чек-лист вещей'],
  pickupInfo: ['픽업 정보', 'Pickup info', 'Thông tin đón', 'Информация о трансфере'],
  hotelMissing: ['호텔 미입력', 'Hotel not entered', 'Chưa nhập khách sạn', 'Отель не указан'],
  confirmNo: ['컨펌넘버', 'Conf. no.', 'Mã xác nhận', 'Номер брони'],
  e2eeMissing: ['여행사 암호화 키가 준비되지 않았어요. 잠시 후 다시 시도해 주세요.', 'Agency encryption key is not ready. Try again shortly.', 'Khóa mã hóa công ty chưa sẵn. Thử lại sau.', 'Ключ шифрования агентства ещё не готов. Повторите позже.'],
  travelerSaved: ['여행자 정보가 저장됐어요. 출발 전 담당자 정보를 안내드릴게요.', 'Traveler details saved. We’ll share staff info before departure.', 'Đã lưu thông tin du khách. Sẽ gửi nhân sự trước khi khởi hành.', 'Данные сохранены. Персонал сообщим до выезда.'],
  bookingMissing: ['예약 정보를 불러올 수 없어요', 'Could not load the booking', 'Không tải được đặt chỗ', 'Не удалось загрузить бронь'],
  staffSaved: ['담당자 배정이 저장됐어요. 알림을 발송했어요.', 'Staff assignment saved. Notification sent.', 'Đã lưu phân công. Đã gửi thông báo.', 'Назначение сохранено. Уведомление отправлено.'],
};

const insurance = {
  title: ['여행자보험', 'Travel insurance', 'Bảo hiểm du lịch', 'Страховка'],
  company: ['보험사', 'Insurer', 'Công ty bảo hiểm', 'Страховщик'],
  policyNo: ['증권번호', 'Policy number', 'Số hợp đồng', 'Номер полиса'],
  downloadSoon: ['증권 다운로드 (준비 중)', 'Download policy (coming soon)', 'Tải hợp đồng (sắp có)', 'Скачать полис (скоро)'],
};

function buildLang(i) {
  return {
    travelProfileFields: pick(extraFields, i),
    travelProfileErrors: pick(extraErrors, i),
    travelerForm: pick(formUi, i),
    travelerOcr: pick(ocr, i),
    travelerCompanion: pick(companion, i),
    teamFile: pick(teamFile, i),
    travelerInsurance: pick(insurance, i),
  };
}

export const phaseTravelerFormKo = buildLang(0);
export const phaseTravelerFormEn = buildLang(1);
export const phaseTravelerFormVi = buildLang(2);
export const phaseTravelerFormRu = buildLang(3);
